/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SpinWheelResponseWheelConfig } from './SpinWheelResponseWheelConfig';
import {
    SpinWheelResponseWheelConfigFromJSON,
    SpinWheelResponseWheelConfigFromJSONTyped,
    SpinWheelResponseWheelConfigToJSON,
    SpinWheelResponseWheelConfigToJSONTyped,
} from './SpinWheelResponseWheelConfig';

/**
 * 
 * @export
 * @interface FuelUpWheelConfigResponse
 */
export interface FuelUpWheelConfigResponse {
    /**
     * 
     * @type {SpinWheelResponseWheelConfig}
     * @memberof FuelUpWheelConfigResponse
     */
    wheelConfig: SpinWheelResponseWheelConfig;
}

/**
 * Check if a given object implements the FuelUpWheelConfigResponse interface.
 */
export function instanceOfFuelUpWheelConfigResponse(value: object): value is FuelUpWheelConfigResponse {
    if (!('wheelConfig' in value) || value['wheelConfig'] === undefined) return false;
    return true;
}

export function FuelUpWheelConfigResponseFromJSON(json: any): FuelUpWheelConfigResponse {
    return FuelUpWheelConfigResponseFromJSONTyped(json, false);
}

export function FuelUpWheelConfigResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FuelUpWheelConfigResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'wheelConfig': SpinWheelResponseWheelConfigFromJSON(json['wheelConfig']),
    };
}

export function FuelUpWheelConfigResponseToJSON(json: any): FuelUpWheelConfigResponse {
    return FuelUpWheelConfigResponseToJSONTyped(json, false);
}

export function FuelUpWheelConfigResponseToJSONTyped(value?: FuelUpWheelConfigResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'wheelConfig': SpinWheelResponseWheelConfigToJSON(value['wheelConfig']),
    };
}

